import { UseFormReturn } from "react-hook-form";
import { RESERVE_TEXTS } from "@/lib/utils-reserve";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { cn } from "@gettactic/helpers";
import { InputLabel } from "../components/InputLabel/InputLabel";
import { Collapse } from "@mantine/core";
import ReserveFieldDescription from "@/components/reserve/ReserveFieldDescription/ReserveFieldDescription";
import React from "react";
import { DescriptionIcon } from "@gettactic/components/src/icons/TacticIcons/DescriptionIcon";
import { Button } from "@v2/components/ui/button";
import { useIsDesignSystem2 } from "@gettactic/hooks";
type ReserveTitleProps = {
  form: UseFormReturn<any>;
  withDescription?: boolean;
  showLabel?: boolean;
};

export default function ReserveFieldTitle({ form, withDescription, showLabel = true }: ReserveTitleProps) {
  const [notesOpened, setNotesOpened] = React.useState(false);
  const isV2 = useIsDesignSystem2();
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              {/* real wrapper that owns the rainbow */}
              <div className=" rounded-md text-base ">
                {showLabel && <InputLabel htmlFor="title">Title</InputLabel>}
                <div className="flex items-stretch gap-2 ">
                  <div className="[.tactic-v2_&]:focus-ring-rainbow flex-1">
                    <Input
                      variant={isV2 ? "v2" : "default"}
                      placeholder={RESERVE_TEXTS.addTitle}
                      className={cn(
                        "flex-1 focus:outline-none focus-visible:outline-none"
                      )}
                      {...field}
                    />
                  </div>
                  {withDescription && <Button
                    type="button"
                    className="flex h-[42px] w-[47px] flex-shrink-0 items-center justify-center gap-[66px] rounded-lg border border-input [.tactic-v2_&]:border-neutral-200 bg-white px-4 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                    
                    "
                    onClick={(e) => {
                      e.preventDefault();
                      setNotesOpened((s) => !s);
                    }}
                    variant="ghost"
                  >
                    <DescriptionIcon />
                  </Button>}
                </div>
                {withDescription && <Collapse in={notesOpened}>
                  <div className="mt-3">
                    <ReserveFieldDescription form={form} />
                  </div>
                </Collapse>}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
